import { useState } from 'react'
import { Switch } from '@/view/components/ui/switch'
import { cn } from '@/app/utils/cn'
import { TriStateEnum } from '@/app/entities/TriState'

type SwitchState = TriStateEnum

interface TriStateSwitchProps {
  value?: SwitchState
  onChange?: (state: SwitchState) => void
  disabled?: boolean
}

export function TriStateSwitch({ 
  value, 
  onChange,
  disabled = false 
}: TriStateSwitchProps) {
  const [internalState, setInternalState] = useState<SwitchState>(value || TriStateEnum.OFF)
  
  const currentState = value !== undefined ? value : internalState

  const handleClick = () => {
    if (disabled) return
    let nextState: SwitchState
    if (currentState === TriStateEnum.OFF) {
      nextState = TriStateEnum.ON
    } else if (currentState === TriStateEnum.ON) {
      nextState = TriStateEnum.FULL
    } else {
      nextState = TriStateEnum.OFF
    }
    if (value === undefined) {
      setInternalState(nextState)
    }
    
    onChange?.(nextState)
  }

  const getBackgroundColor = () => {
    switch (currentState) {
      case TriStateEnum.OFF:
        return 'data-[state=unchecked]:bg-gray-300 data-[state=checked]:bg-gray-300'
      case TriStateEnum.ON:
        return 'data-[state=checked]:bg-gray-400'
      case TriStateEnum.FULL:
        return 'data-[state=checked]:bg-primary'
      default:
        return 'data-[state=unchecked]:bg-gray-300'
    }
  }

  const isActive = currentState !== TriStateEnum.OFF

  return (
    <Switch
      checked={isActive}
      onCheckedChange={handleClick}
      disabled={disabled}
      className={cn(getBackgroundColor())}
    />
  )
}